/* eslint-disable max-len */
import Command from "@ckeditor/ckeditor5-core/src/command";
import { CkeditorConstants } from "../../src/utils";

const {
  command: { SELECT_ALL },
  event: { EXECUTE },
  htmlElement: { SPAN, LINK_SPAN }
} = CkeditorConstants;
export default class TemplateHoverAndSelectAllCommand extends Command {
  execute() {
    const editor = this.editor;
    const editingView = this.editor.editing.view;
    const viewDocument = editingView.document;
    const { model: { document: { selection } }} = editor;

    /* Select All Feature for selecting current focused elements */
    viewDocument.on("click", (event, data) => {
        let startPos = null;
        let endPos = null;
        let isSectionTagAvailable = null;
        for (const childItems of data.target.getChildren()) {
          if (childItems.name === "section") {
            isSectionTagAvailable = true;
            break;
          }
        }
        const modelElement = selection.anchor.getAncestors().reverse().find((ele) => {
          return (ele.name !== SPAN && ele.name !== LINK_SPAN);
        });
        const selectAll = editor.commands.get(SELECT_ALL);
        this.listenTo( selectAll, EXECUTE, () => {
          editor.model.change((writer) => {
            if(modelElement) {
              const range = editor.model.createRangeIn(modelElement);
              if (isSectionTagAvailable) {
                for (const value of range.getWalker()) {
                  if (!startPos) {
                    startPos = writer.createPositionAt(value.item, 0);
                  }
                  if (value.item.name === "section" && !endPos) {
                    endPos = writer.createPositionBefore(value.item);
                  }
                }
              } else {
                startPos = writer.createPositionAt(modelElement, 0);
                endPos = writer.createPositionAt(modelElement, "end");
              }
              const range2 = writer.createRange(startPos, endPos);
              writer.setSelection(range2);
              isSectionTagAvailable = null;
            }
          });
        });
      },
      { priority: "highest" }
    );
  }
}
